// src/features/landing/presentation/components/HeroTopNav.jsx
import React from "react";
import { Link } from "react-router-dom";

export function HeroTopNav({ visible = true }) {
    return (
        <div
            className={`hero-nav ${
                visible ? "hero-nav--visible" : "hero-nav--hidden"
            }`}
        >
            <div className="navbar-inner hero-nav-inner">
                <Link to="/" className="navbar-logo">
                    <span className="navbar-logo-main">RISING</span>
                    <span className="navbar-logo-sub">BROKERS</span>
                </Link>
                <nav className="navbar-menu">
                    <Link to="/about">회사소개</Link>
                    <Link to="/service">서비스</Link>
                    <Link to="/premium">프리미엄 채용관</Link>
                    <Link to="/contact">제휴문의</Link>
                </nav>
            </div>
        </div>
    );
}
